import { render, staticRenderFns } from "./OrderManagementAll.vue?vue&type=template&id=38ece560&scoped=true&"
import script from "./OrderManagementAll.vue?vue&type=script&lang=js&"
export * from "./OrderManagementAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ece560",
  null
  
)

export default component.exports